import scss from './tooltipMarkup.module.scss';

const createTooltipMarkup = ({ tooltipModel }) => {
  if (!tooltipModel) {
    return '';
  }

  const dataPoint = tooltipModel.dataPoints[0];
  const title = tooltipModel.title[0];

  const color = dataPoint.dataset.backgroundColor[dataPoint.dataIndex % dataPoint.dataset.backgroundColor.length];

  return `
    <div class='${scss.outerBox}'>
      <div class='${scss.infoBlock}'>
        <div class='${scss.record}'>
          <div class="${scss.marker}" style="background-color: ${color}"></div>
          <span class='${scss.label}'>${title}:</span>
          <span class='${scss.value}'>${dataPoint.raw}%</span>
        </div>
      </div>
    </div>
  `;
};

export default createTooltipMarkup;
